import React from "react";
import Message from "./Message";
import { useEffect, useContext, useRef } from "react";
import { ConversationContext } from "../../contexts/ChatContext/ConversationContext"
import { ChatContext } from "../../contexts/ChatContext/ChatContext";

const Conversation = () => {
    const scrollAuto = useRef(null);
    const hasFetched = useRef(false);
    
    const { thread_id } = useContext(ChatContext);
    const { conversation, setConversation, GetConversation } = useContext(ConversationContext);

    useEffect(() => {
        if (hasFetched.current === thread_id) return;
        
        setConversation([]);
        localStorage.setItem("thread_id", thread_id);
        GetConversation(thread_id);
    
        hasFetched.current = thread_id;
    }, [thread_id, GetConversation, setConversation]);    

    useEffect(() => {
        scrollAuto.current?.scrollTo({
            top: scrollAuto.current.scrollHeight,
            behavior: "smooth",
        });
    }, [conversation]);

    return (
        <div ref={scrollAuto} className="w-full overflow-y-auto">
            {conversation.flatMap((msg, index) => {
                const messages = [];

                if (msg.question) {
                    messages.push(
                        <Message
                            key={`q-${index}`}
                            full_name={msg.full_name}
                            text={msg.question}
                            formatted_date={msg.formatted_date}
                        />
                    );
                }

                if (msg.answer) {
                    messages.push(
                        <Message
                            key={`a-${index}`}
                            full_name="Asistente"
                            text={msg.answer}
                            formatted_date={msg.formatted_date}
                        />
                    );
                }

                return messages;
            })}
        </div>
    );
  };
  
  export default Conversation;
  